'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = uid;
function uid() {
  return Array.from({ length: 128 / 16 }, function () {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }).join('');
}
//# sourceMappingURL=uid.js.map